import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularFontAwesomeModule } from 'angular-font-awesome';
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';
import { Routes, RouterModule } from '@angular/router';
import { AppRoutingModule } from '../../app-routing.module';
import { MatSidenavModule } from '@angular/material';
import { SharedComponentsModule } from '../../shared-components/shared-components.module';
import { DocumetationComponent } from './documentation.component';
import { BsDropdownModule } from 'ngx-bootstrap';

@NgModule({
  imports: [
    CommonModule,
    MatSidenavModule,
    AppRoutingModule
  ],
  declarations: [
    DocumetationComponent
  ],
  exports: [
    DocumetationComponent
  ]
})
export class DocumentationModule { }



// WEBPACK FOOTER //
// ./src/app/pages/documentation/documentation.module.ts